import { render, staticRenderFns } from "./LandCard.vue?vue&type=template&id=70e5945e&scoped=true"
import script from "./LandCard.vue?vue&type=script&lang=js"
export * from "./LandCard.vue?vue&type=script&lang=js"
import style0 from "./LandCard.vue?vue&type=style&index=0&id=70e5945e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5945e",
  null
  
)

export default component.exports